import JobWorkerInterviewType from "@/models/JobWorkerInterviews/JobWorkerInterviewType";
import JobStage from "@/models/Jobs/JobStage";

export default (value: JobWorkerInterviewType) => {
    switch (value) {
        case JobWorkerInterviewType.Telephone:
            return "Telephone";
        case JobWorkerInterviewType.Online:
            return "Online";
        case JobWorkerInterviewType.InPerson:
            return "In Person";
        default:
            return "Unknown";
    }
} 